import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl-phraseapp";
import { useTranslate } from "../../helpers";
import {
  linkToSpecialEnrollmentPeriodInfo,
  linkToMedicareAndYou,
} from "../../helpers/CONSTANTS";
import { AppContext } from "../../app/store";

const OutsideOpenEnrollmentHelp: FunctionComponent = () => {
  const t = useTranslate();
  const {
    state: { language },
  } = useContext(AppContext);

  return (
    <>
      <p>
        <FormattedHTMLMessage id="ooe_help.before_you_enroll" />
      </p>
      <ul>
        <li>
          <FormattedMessage
            id="ooe_help.visit"
            tagName="span"
            values={{
              link: (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://ssa.gov/benefits/medicare"
                >
                  ssa.gov/benefits/medicare
                </a>
              ),
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="ooe_help.call"
            tagName="span"
            values={{
              phoneNumber: (
                <a href={`tel:${t("ooe_help.call_number")}`}>
                  {t("ooe_help.call_number")}
                </a>
              ),
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="ooe_help.tty"
            tagName="span"
            values={{
              phoneNumber: (
                <a href={`tel:${t("ooe_help.tty_number")}`}>
                  {t("ooe_help.tty_number")}
                </a>
              ),
            }}
          />
        </li>
      </ul>
      <p>{t("ooe_help.you_can_enroll")}</p>

      <h4 className="ds-u-margin-top--5 ds-u-margin-bottom--0">
        {t("ooe_help.initial_enrollment_period")}
      </h4>
      <p>{t("ooe_help.iep_explanation")}</p>

      <h4 className="ds-u-margin-top--5 ds-u-margin-bottom--0">
        {t("ooe_help.special_enrollment_period")}
      </h4>
      <FormattedMessage
        id="ooe_help.sep_explanation"
        tagName="p"
        values={{
          link: (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={linkToSpecialEnrollmentPeriodInfo(language)}
            >
              {t("ooe_help.sep_link")}
            </a>
          ),
        }}
      />

      <h4 className="ds-u-margin-top--5 ds-u-margin-bottom--0">
        {t("ooe_help.medicare_advantage_open_enrollment")}
      </h4>
      <p>{t("ooe_help.ma_oe_dates")}</p>
      <ul>
        <li>{t("ooe_help.ma_oe_switch_plan")}</li>
        <li>{t("ooe_help.ma_oe_drop_plan")}</li>
      </ul>
      <p>
        <FormattedHTMLMessage id="ooe_help.ma_oe_note" />
      </p>

      <h4 className="ds-u-margin-top--5 ds-u-margin-bottom--0">
        {t("ooe_help.general_enrollment_period")}
      </h4>
      <p>{t("ooe_help.gep_explanation")}</p>
      <FormattedMessage
        id="ooe_help.medicare_and_you"
        tagName="p"
        values={{
          medicareAndYouLink: (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={linkToMedicareAndYou(language)}
            >
              {t("ooe_help.medicare_and_you_link")}
            </a>
          ),
        }}
      />
    </>
  );
};

export default OutsideOpenEnrollmentHelp;
